var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Combine multiple tracking properties into one accumulating the properties and encrypted properties.
 *
 * The properties are accumulated by spreading the properties of each tracking properties object into a new object
 * forcing the properties of the last object to overwrite the properties of the previous objects.
 */
export var combineProps = function () {
    var props = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        props[_i] = arguments[_i];
    }
    return ({
        properties: __assign({}, props.reduce(function (acc, curr) { return (__assign(__assign({}, acc), curr === null || curr === void 0 ? void 0 : curr.properties)); }, {})),
        encryptedProperties: props.flatMap(function (x) { var _a; return (_a = x === null || x === void 0 ? void 0 : x.encryptedProperties) !== null && _a !== void 0 ? _a : []; }),
    });
};
//# sourceMappingURL=tracking.js.map